import styled from 'styled-components'
import { TableCell, TableRow } from '@material-ui/core'
import { colors } from '../../../../../theme/Global'

export const CustomTableBodyCell = styled(TableCell)`
  && {
    padding: 0 25px 0 25px;
    text-align: left;
    vertical-align: top;
    & > div {
      width: ${(props) => props.cellwidth};
    }
    background-color: ${colors.white};
    &.sticky {
      position: -webkit-sticky;
      position: sticky;
      left: 0;
      top: 0;
      z-index: 1;
      box-shadow: inset -1px 0px 3px -2px ${colors.darkGrey};
    }
  }
`

export const CustomTableBodyRow = styled(TableRow)`
  && {
    border-bottom-color: ${colors.darkGrey};
  }
`

export const StyledCell = styled.div`
  font-size: 12px;
  padding: 1rem 0;
`
